export enum BaseWebsocketClientToServerMessageType {
  Pong = 'pong',

  PeerMessage = 'peer-message',
}

export type BaseWebsocketClientToServerPongMessage = {
  type: BaseWebsocketClientToServerMessageType.Pong;
  timestamp: number;
};

export type BaseWebsocketClientToServerPeerMessage<Message> = {
  type: BaseWebsocketClientToServerMessageType.PeerMessage;
  toPeerIds: string[];
  message: Message;
};

export type BaseWebsocketClientToServerMessage<Message = any> =
  | BaseWebsocketClientToServerPongMessage
  | BaseWebsocketClientToServerPeerMessage<Message>;

export const isBaseWebsocketClientToServerMessage = (
  message: unknown,
): message is BaseWebsocketClientToServerMessage => {
  if (typeof message !== 'object' || message === null) {
    return false;
  }

  if (!('type' in message) || typeof message.type !== 'string') {
    return false;
  }

  const validTypes = Object.values(BaseWebsocketClientToServerMessageType) as string[];

  if (!validTypes.includes(message.type)) {
    return false;
  }

  return true;
};
